import React, {useContext} from 'react'
import {AuthContext} from '../../../../context/auth-context';

const Name = ({placeholder}) => {
    const {user} = useContext(AuthContext);
    return user ? <div className="namelink">{user.firstName} {user.lastName}</div> : placeholder;
}
export default Name;
